// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatProjectsPageHeader-modulecount__KtUFE";
var _2 = "GretaAIChatProjectsPageHeader-moduleheader__OZPyO";
var _3 = "GretaAIChatProjectsPageHeader-moduleheading__y7s0K";
var _4 = "GretaAIChatProjectsPageHeader-moduletitle__Acuxb";
export { _1 as "count", _2 as "header", _3 as "heading", _4 as "title" }
